<header class="header ios-padding-left ios-padding-right" [elevation]="4" rsWebElevation>
  <button
    im-icon-button
    class="header__navigation-toggle"
    aria-label="Toggle navigation"
    (click)="onNavigationToggleClick($event)"
  >
    <i [class]="navigationOpen ? 'icon-close' : 'icon-context'"></i>
  </button>

  <rs-web-logo></rs-web-logo>

  <nav class="header__nav">
    <div class="header__nav-item header__nav-item--user-menu">
      <button (click)="onProfileSettingsToggleClick($event)">
        <rs-web-avatar
          class="header__profile-settings-toggle"
          [userData]="userData$ | async"
          [size]="avatarSize['SMALL']"
          [rounded]="true"
        ></rs-web-avatar>
      </button>
    </div>
  </nav>
</header>
